import {
  CalendarOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  DownOutlined,
  FolderOpenOutlined,
  HddOutlined,
  HomeOutlined,
  MailOutlined,
  PhoneOutlined,
  PlusSquareOutlined,
  UserOutlined
} from "@ant-design/icons";
import { DatePicker, Flex, Form, Input, Radio, Select } from "antd";
import { useForm } from "antd/es/form/Form";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as customerApi from "../../../../../api/customer/customerApi";
import { addRelativeCustomer_V4 } from "../../../../../api/relatives/relativesApi";
import {
  getListCustomerTypes,
  ICustomerTypes,
} from "../../../../../api/selectOption/selectOptionsApi";
import * as selectOptionsApi from "../../../../../api/selectOptions/selectOptionsApi";
import {
  ho_chieu,
  icon_delelte,
  icon_document,
} from "../../../../../components/ExportImgFigma";
import UploadImage from "../../../../../components/Upload/UploadImage";
import useDebounce from "../../../../../hook/useDebounce";
import useThrottle from "../../../../../hook/useThrottle";
import useToast from "../../../../../hook/useToast";
import {
  dataCarCustomerTypes,
  dataStatusMarital,
  dataTypeAddress,
  dataTypeCustomer,
  dataTypeCustomer2,
  dataTypeDocument,
  genders,
} from "../../../../../services/data";
import { selectorInfoUser } from "../../../../../store/slices/infoUserSlice";
import {
  fommatSelectOption,
  fommatSelectOptionListType,
  fommatSelectOptionUnitByUser,
  getTitleSelectOption,
  handleDateChangeDayJs
} from "../../../../../until";
import "./PersonalInformation.scss";
import { OptionType } from "./PersonalInformationUpdate";

import { selectorUnitByUserPermission } from "../../../../../store/slices/UnitByUserPermission";
import './style.scss';

interface Props {
  isFormSubmitted?: boolean;
  onSuccess?: (formData: any) => void;
  setIsFormSubmitted?: (value: boolean) => void;

  resultFormSubmit?: (
    iSsuccess: boolean,
    message?: string,
    data?: customerApi.ICustomerDetail_V3
  ) => void;
}

interface CustomerFilterSearch {
  customerStatus?: string;   // tình trạng khách hàng (multiple select)
  customerInterest?: string; // sở thích khách hàng (multiple select)
  customerGroup?: string;    // nhóm khách hàng (multiple select)
  searchProvice?: string;
  searchInformationChannel?: string;
  searchBusinessFieldId?: string
  searchDistrict?: string
  searchProfession?: string
}

const PersonalInformation: React.FC<Props> = (props) => {
  const { isFormSubmitted, onSuccess, setIsFormSubmitted, resultFormSubmit } =
    props;
  const formRef: any = useRef(null);
  const [form] = useForm();
  const pushToast = useToast();
  const navigate = useNavigate();

  const { unitTemp } = useSelector(selectorInfoUser);
  const unitByUserPermissionSlice = useSelector(selectorUnitByUserPermission)

  useEffect(() => {
    form.setFieldValue("businessCheck", 0);
    form.setFieldValue("type", 0);
    form.setFieldValue("listType", [5]);
    setTagCustomerType([5])

    gSLProfession();
    gSLTypePhone();
    gSLCustomerTypes();
    gBusinessField();
    gSLInformationChannel()
    return () => {
      setAvatar(null);
      setSex(0);
      setName("");
      setMarital(0);
      setProfession(0);
      setIdentityType(0);
      setHobbyID([]);
      setGroup([]);
      setProvice(undefined);
      setAddress("");

      if (formRef.current) {
        formRef.current.resetFields(); // Reset toàn bộ form
      }
    };
  }, []);


  const [sLInformationChannel, setSLInformationChannel] = useState<selectOptionsApi.ISelectOption[]>([]);
  const [sLProfession, setSLProfession] = useState<selectOptionsApi.ISelectOption[]>([]);
  const [sLHobby, setSLHobby] = useState<selectOptionsApi.ISelectOption[]>([]);
  const [sLGroup, setSLGroup] = useState<selectOptionsApi.ISelectOption[]>([]);
  const [sLProvice, setSLProvice] = useState<selectOptionsApi.ISelectOption[]>([]);
  const [sLDistrict_V2, setSLDistrict_V2] = useState<
    Record<number, OptionType[]>
  >({});
  const [sLTypePhone, setSLTypePhone] = useState<
    selectOptionsApi.ISelectOption[]
  >([]);
  const [sLCustomerType, setSLCustomerType] = useState<ICustomerTypes[]>([]);
  const [sLCarType, setSLCarType] =
    useState<ICustomerTypes[]>(dataCarCustomerTypes);
  const [sLBusinessField, setSLBusinessField] = useState<
    selectOptionsApi.ISelectOption[]
  >([]);

  const [avatar, setAvatar] = useState<File | null>();
  const [typeCustomer, setTypeCustomer] = useState(0);
  const [identityType, setIdentityType] = useState(0);
  const [sex, setSex] = useState<number>(2);
  const [name, setName] = useState<string>("");
  const [marital, setMarital] = useState<number>(2);
  const [profession, setProfession] = useState<number>();
  // const [birthday, setBirthday] = useState<string>()
  const [dayCreate, setDayCreate] = useState<string>();
  const [email, setEmail] = useState<string>("");
  // const [phone, setPhone] = useState<string>()
  const [hobbyID, setHobbyID] = useState<number[]>([]);
  const [group, setGroup] = useState<number[]>([]);
  const [provice, setProvice] = useState<number>();
  const [address, setAddress] = useState<string>();
  const [phoneTypeTmp, setPhoneTypeTmp] = useState<{ [key: number]: number }>(
    {}
  );
  const [namebusiness, setNamebusiness] = useState<string>("");
  const [searchProvice, setSearchProvice] = useState<string>("");
  const [searchDistrict, setSearchDistrict] = useState<string>("");
  const [searchHobby, setSearchHobby] = useState<string>("");
  const [searchProfession, setSearchProfession] = useState<string>("");
  const [searchGroup, setSearchGroup] = useState<string>("");
  const [tagGroupPersonally, setTagGroupPersonally] = useState<number[]>([]);
  const [tagGroupBusiness, setTagGroupBusiness] = useState<number[]>([]);
  const [tagCustomerType, setTagCustomerType] = useState<number[]>([]);
  const [tagCarType, setTagCarType] = useState<number[]>([]);
  const [valuesTagHobby, setValuesTagHobby] = useState<number[]>([]);
  const [openTagGroup, setOpenTagGroup] = useState(false);
  const [openTagGroupBusiness, setOpenTagGroupBusiness] = useState(false);
  const [openTagHobby, setOpenTagHobby] = useState(false);
  const [openTagCustomerType, setOpenTagCustomerType] = useState(false);
  const [openTagCarType, setOpenTagCarType] = useState(false);
  const [businessField, setBusinessField] = useState<number>();


  const [searchFilters, setSearchFilters] = useState<CustomerFilterSearch>();

  const gSLInformationChannel = useDebounce(async () => {
    const result = await selectOptionsApi.getListInformationChannel(searchFilters?.searchInformationChannel);
    if (result?.status) {
      setSLInformationChannel(fommatSelectOption(result.data));
    } else {
      pushToast(result?.message, "error");
    }
  }, 500);

  const gSLProfession = useDebounce(async () => {
    const result = await selectOptionsApi.getCLProfession(searchFilters?.searchProfession);
    if (result?.status) {
      setSLProfession(fommatSelectOption(result.data));
    } else {
      pushToast(result?.message, "error");
    }
  }, 500);

  const gSLTypePhone = async () => {
    const result = await selectOptionsApi.getListTypePhone();
    if (result?.status) {
      setSLTypePhone(fommatSelectOption(result.data));
    } else {
      pushToast(result?.message, "error");
    }
  };

  const gSLCustomerTypes = async () => {
    const result = await getListCustomerTypes(searchFilters?.customerStatus);
    if (result?.status) {
      setSLCustomerType(result.data);
    } else {
      pushToast(result?.message, "error");
    }
  };

  const gSLHobby = useDebounce(async () => {
    const result = await selectOptionsApi.getListHobby(searchFilters?.customerInterest);
    if (result?.status) {
      setSLHobby(fommatSelectOption(result.data));
    } else {
      pushToast(result?.message, "error");
    }
  }, 500);

  const gSLGroup = useDebounce(async () => {
    const result = await selectOptionsApi.getListGroup(searchFilters?.customerGroup);
    if (result?.status) {
      setSLGroup(fommatSelectOption(result.data));
    } else {
      pushToast(result?.message, "error");
    }
  }, 500);

  const gSLDistrict_V2 = async (
    provinceId: number,
    index: number,
    search?: string
  ) => {
    const result = await selectOptionsApi.getListDistrict(
      Number(provinceId),
      search
    );
    if (result?.status) {
      setSLDistrict_V2((prev) => ({
        ...prev,
        [index]: fommatSelectOption(result.data),
      }));
    } else {
      pushToast(result?.message, "error");
    }
  };


  const gBusinessField = useDebounce(async () => {
    const result = await selectOptionsApi.getBusinessField(searchFilters?.searchBusinessFieldId);
    if (result?.status) {
      setSLBusinessField(fommatSelectOption(result.data));
    } else {
      pushToast(result?.message, "error");
    }
  }, 500);

  const gSLProvice = useDebounce(async () => {
    const result = await selectOptionsApi.getListProvince(searchFilters?.searchProvice);
    if (result?.status) {
      setSLProvice(fommatSelectOption(result.data));
    } else {
      pushToast(result?.message, "error");
    }
  }, 500);
  const handleSearchProvice = (value: string) => {
    setSearchProvice(value);
  };

  const onChangeProvice_V2 = (value?: number, i?: number) => {
    if (!value) {
      setSearchProvice("");
      setSLDistrict_V2((prev) => ({ ...prev, [Number(i)]: [] }));
    } else {
      setProvice(value);
      gSLDistrict_V2(value, Number(i));
    }
  };


  // FORM SUBMIT
  const onFormSubmit = (values: any) => {
    confimSubmit(values);
  };

  const confimSubmit = useThrottle(async (values: any) => {
    const {
      businessCheck, type, username, CCCD, passport, phone, email, contactMethod, listType,
      listTypeCar, hobby, groupCustomerId, description, taxcode, address, birthday,
      professionId, foundingDate, businessFieldId, informationChannel, unitId
    } = values;

    // const validUnitTemp = unitTemp ?? undefined;
    const validBirthday = birthday ? birthday?.format("YYYY/MM/DD") : undefined;
    const validEmails = email
      .map((item: any) => item?.email)
      .filter((email: any) => typeof email === "string" && email.trim() !== "");
    const validAddresses = address.filter(
      (item: any) =>
        (item.provinceId !== null && item.provinceId !== undefined) ||
        (item.address && item.address.trim() !== "")
    );
    const validFoundingDate = foundingDate
      ? foundingDate?.format("YYYY/MM/DD")
      : undefined;

    // Kiểm tra số điện thoại trùng lặpừ
    const phoneNumbers = phone?.map((item: any) => item.phone);
    const uniqueNumbers = new Set(phoneNumbers);

    if (phoneNumbers.length !== uniqueNumbers.size) {
      pushToast("Các số điện thoại không được trùng lặp", "error");
      setIsFormSubmitted?.(false);
      return; // Dừng xử lý nếu phát hiện trùng lặp
    }

    const result = await addRelativeCustomer_V4(
      businessCheck, username, phone, informationChannel,
      type, unitTemp, CCCD, sex,
      marital, listType, professionId, validBirthday,
      validEmails, contactMethod, listTypeCar, validAddresses,
      avatar, groupCustomerId, hobby, 0,
      undefined, undefined, description, taxcode,
      validFoundingDate,
      undefined //  businessFieldId 
      , undefined
    );
    if (result?.status) {
      resultFormSubmit?.(true, result?.message, result.data);
      setIsFormSubmitted?.(false);
      // navigate(-1)
    } else {
      resultFormSubmit?.(false, result?.message);
      setIsFormSubmitted?.(false);
    }
  }, 2000);

  const handleSearchDistrict = (value: string, i: number) => {
    const provinceId = form.getFieldValue(["address", i, "provinceId"]);
    if (provinceId)
      gSLDistrict_V2(provinceId, i, value)
  };

  const handleChangeTagGroup = (selectedValues: number[]) => {
    setSearchFilters({ ...searchFilters, customerGroup: '' })
    setTagGroupPersonally(selectedValues);
    setOpenTagGroup(false);
    form.setFieldsValue({ groupCustomerId: selectedValues }); // Update field value
    form.validateFields(["groupCustomerId"]); // Validate field to update error status
  };

  const handleChangeTagHobby = (selectedValues: number[]) => {
    setSearchFilters({ ...searchFilters, customerInterest: '' })
    setValuesTagHobby(selectedValues);
    setOpenTagHobby(false);
    form.setFieldsValue({ hobby: selectedValues });
    form.validateFields(["hobby"]);
  };

  const handleChangeTagCustomertype = (selectedValues: number[]) => {
    setSearchFilters({ ...searchFilters, customerStatus: '' })

    // console.log(selectedValues)
    setTagCustomerType(selectedValues);
    setOpenTagCustomerType(false);
    form.setFieldsValue({ listType: selectedValues });
    form.validateFields(["listType"]);
  };
  const handleChangeTagCartype = (selectedValues: number[]) => {
    setTagCarType(selectedValues);
    setOpenTagCarType(false);
    form.setFieldsValue({ listTypeCar: selectedValues });
    form.validateFields(["listTypeCar"]);
  };
  useEffect(() => {
    gSLProvice();
  }, [searchFilters?.searchProvice]);

  // useEffect(() => {
  //   gSLHobby();
  // }, [searchHobby]);
  // useEffect(() => {
  //   gSLProfession();
  // }, [searchProfession]);
  // useEffect(() => {
  //   gSLDistrict_V2();
  // }, [searchFilters?.searchDistrict]);

  useEffect(() => {
    gSLProfession();
  }, [searchFilters?.searchProfession]);

  useEffect(() => {
    gBusinessField();
  }, [searchFilters?.searchBusinessFieldId]);

  useEffect(() => {
    gSLCustomerTypes();
  }, [searchFilters?.customerStatus]);

  useEffect(() => {
    gSLHobby();
  }, [searchFilters?.customerInterest]);

  useEffect(() => {
    gSLGroup();
  }, [searchFilters?.customerGroup]);

  useEffect(() => {
    gSLInformationChannel();
  }, [searchFilters?.searchInformationChannel]);

  useEffect(() => {
    setTagGroupPersonally([]);
    setTagGroupBusiness([]);
    setValuesTagHobby([]);

    // setTagCustomerType([]);
    setSex(2);
    setMarital(2);
  }, [typeCustomer]);

  useEffect(() => {
    if (isFormSubmitted) {
      formRef?.current.submit();
    }
  }, [isFormSubmitted]);

  return (
    <Form ref={formRef} form={form} className="rs-form" onFinish={onFormSubmit}>
      <div className="personal-information justify-between">
        <div className="d-flex flex-column w-1060-px">
          <div className="personal-information__left">
            <div className="info-left w-530-px">
              <div className="d-flex gap-10-px w-full">
                <Form.Item
                  name="businessCheck"
                  className="custom-placeholder w-half"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng chọn loại khách hàng",
                    },
                  ]}
                >
                  <Select
                    placeholder="Chọn loại khách hàng"
                    className="custom-page-css border rounded overflow-hidden"
                    showSearch
                    filterOption={false}
                    options={dataTypeCustomer}
                    value={typeCustomer}
                    onChange={(e) => setTypeCustomer(e)}
                  />
                </Form.Item>
                <Form.Item
                  name="type"
                  className="custom-placeholder w-half"
                // rules={[
                //   { required: true, message: 'Vui lòng chọn loại khách hàng' }
                // ]}
                >
                  <Select
                    placeholder="Chọn loại khách hàng"
                    className="custom-page-css border rounded overflow-hidden"

                    showSearch
                    filterOption={false}
                    options={dataTypeCustomer2}
                  />
                </Form.Item>
              </div>

              {typeCustomer === 0 && (
                <div
                  className="custom-page-css w-full flex items-center justify-between"
                >
                  <Radio.Group
                    // className="rs-radio-group"
                    value={sex}
                    onChange={(e) => setSex(e.target.value)}
                  >
                    {genders.map((item: any) => (
                      <Radio.Button
                        key={item.value}
                        value={item.value}
                      // style={{
                      //   display: 'flex',
                      //   flexDirection: 'row',
                      //   flexWrap: 'nowrap',
                      //   width: '100%'
                      // }}
                      // className="rs-radio"
                      >
                        <span className="flex-inline align-center gap-8px">
                          {item.icon}
                          {item.label}
                        </span>
                      </Radio.Button>
                    ))}
                  </Radio.Group>

                  <Radio.Group
                    value={marital}
                    // className="rs-radio-group"
                    onChange={(e) => setMarital(e.target.value)}
                  // style={{
                  //       display: 'flex',
                  //       flexDirection: 'row',
                  //       flexWrap: 'nowrap',
                  //       width: '100%'
                  //     }}
                  >
                    {dataStatusMarital.map((item) => (
                      <Radio.Button
                        key={item.value}
                        value={item.value}
                      // className="rs-radio white-space-nowrap"
                      >
                        {item.title}
                      </Radio.Button>
                    ))}
                  </Radio.Group>
                </div>
              )}

              {typeCustomer === 0 ? (
                <Form.Item
                  name="username"
                  rules={[
                    { required: true, message: "Vui lòng nhập Họ và tên" },
                  ]}
                >
                  <Input
                    prefix={<UserOutlined />}
                    placeholder="Họ và tên*"
                    // className="rs-input"
                    className="custom-input-css custom-page-css border py-1"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </Form.Item>
              ) : (
                <Form.Item
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng nhập Tên doanh nghiệp",
                    },
                  ]}
                >
                  <Input
                    prefix={<UserOutlined />}
                    placeholder="Tên doanh nghiệp*"
                    // className="rs-input"
                    className="custom-input-css custom-page-css border py-1"
                    value={namebusiness}
                    onChange={(e) => setNamebusiness(e.target.value)}
                  />
                </Form.Item>
              )}

              {typeCustomer === 0 ? (
                <Form.Item
                  name="birthday"
                  rules={[
                    { required: true, message: 'Vui lòng chọn ngày ghi nhận' }
                  ]}
                >
                  <DatePicker
                    placeholder="Ngày sinh*"
                    prefix={<CalendarOutlined />}
                    suffixIcon={null}
                    popupClassName="rs-date-picker-dropdown"
                    className="w-full custom-input-date"
                    format="DD/MM/YYYY"
                    disabledDate={(current) =>
                      current && current > dayjs().endOf("day")
                    }
                  />
                </Form.Item>

              ) : (
                <Form.Item name="foundingDate">
                  <DatePicker
                    placeholder="Ngày thành lập*"
                    prefix={<CalendarOutlined />}
                    suffixIcon={null}
                    className="w-full custom-input-date"
                    popupClassName="rs-date-picker-dropdown"
                    format="DD/MM/YYYY"
                    disabledDate={(current) =>
                      current && current > dayjs().endOf("day")
                    }
                    value={dayCreate ? dayjs(dayCreate, "YYYY/MM/DD") : null}
                    onChange={(e) => setDayCreate(handleDateChangeDayJs(e))}
                  />
                </Form.Item>
              )}

              {typeCustomer === 0 ? (
                <>
                  <div>
                    <div className="d-flex gap-1 mb-1">

                      {/* INPUT CCCD / PASSPORT */}
                      <Form.Item
                        shouldUpdate={(prev, cur) =>
                          prev?.CCCD?.[0]?.identityType !== cur?.CCCD?.[0]?.identityType
                        }
                        noStyle
                      >
                        {({ getFieldValue }) => {
                          const typeDoc = getFieldValue(["CCCD", 0, "identityType"]);

                          return (
                            <Form.Item
                              className="w-full"
                              name={["CCCD", 0, "name"]}
                              initialValue=""
                              rules={[
                                { required: true, message: "Vui lòng nhập giấy tờ" },
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    const typeDoc = getFieldValue(["CCCD", 0, "identityType"]);

                                    if (!typeDoc && typeDoc !== 0) {
                                      return Promise.reject(
                                        new Error("Vui lòng chọn loại giấy tờ trước")
                                      );
                                    }

                                    if (!value || value.trim() === "") {
                                      return Promise.reject(
                                        new Error("Vui lòng nhập số giấy tờ")
                                      );
                                    }

                                    if (typeDoc === 0 && !/^\d{12}$/.test(value)) {
                                      return Promise.reject(
                                        new Error("CCCD phải gồm đúng 12 chữ số")
                                      );
                                    }

                                    const passport = value?.toUpperCase().trim();

                                    if (typeDoc === 1 && !/^[A-Z0-9]{6,9}$/.test(passport)) {
                                      return Promise.reject(
                                        new Error(
                                          "Số hộ chiếu không hợp lệ (6–9 ký tự chữ hoặc số)"
                                        )
                                      );
                                    }

                                    return Promise.resolve();
                                  },
                                }),
                              ]}
                            >
                              <Input
                                prefix={<img src={ho_chieu} />}
                                placeholder="Nhập số CCCD/Hộ chiếu*"
                                disabled={typeDoc === null || typeDoc === undefined} // ⭐ KEY HERE
                                className="custom-input-css custom-page-css border"
                              />
                            </Form.Item>
                          );
                        }}
                      </Form.Item>

                      {/* SELECT TYPE */}
                      <Form.Item
                        name={["CCCD", 0, "identityType"]}
                        initialValue={null}
                        rules={[{ required: true, message: "Vui lòng chọn loại" }]}
                      >
                        <Select
                          options={dataTypeDocument}
                          placeholder="Loại"
                          className="custom-page-css border rounded overflow-hidden w-200-px"
                          onChange={(val) => {
                            const currentCCCD = form.getFieldValue("CCCD") || [];
                            const currentItem = currentCCCD[0] || {};

                            form.setFieldsValue({
                              CCCD: [
                                {
                                  ...currentItem,
                                  identityType: val,
                                  name: "",
                                  isPrimary: 1,
                                },
                              ],
                            });
                          }}
                        />
                      </Form.Item>

                    </div>

                    {/* Hidden field với giá trị mặc định */}
                    <Form.Item name={["CCCD", 0, "isPrimary"]} initialValue={1} hidden>
                      <Input type="hidden" />
                    </Form.Item>
                  </div>


                </>
              ) : (
                <div className="d-flex gap-10-px">
                  <Form.Item
                    name="taxcode"
                    className="w-full"
                    rules={[
                      { required: true, message: 'Vui lòng nhập mã số thuế' },
                      {
                        validator: (_, value) => {
                          if (!value) return Promise.resolve();
                          const regex = /^\d{10}(\d{3})?$/; // 10 hoặc 13 chữ số
                          if (!regex.test(value)) {
                            return Promise.reject('Mã số thuế phải gồm 10 hoặc 13 chữ số');
                          }
                          return Promise.resolve();
                        }
                      }
                    ]}
                  >
                    <Input
                      prefix={<img src={icon_document} />}
                      placeholder="Mã số thuế*"
                      className="custom-input-css custom-page-css border"
                    />
                  </Form.Item>
                </div>
              )}

              <Form.Item
                name="professionId"
                rules={[
                  {
                    required: true,
                    message: typeCustomer === 0 ? 'Vui lòng nhập Nghề nghiệp' : 'Vui lòng nhập Ngành nghề kinh doanh'
                  }
                ]}
              >
                <Select
                  placeholder={typeCustomer === 0 ? "Nghề nghiệp*" : "Ngành nghề kinh doanh*"}
                  className="custom-page-css border rounded overflow-hidden"
                  // className=""
                  prefix={<FolderOpenOutlined />}

                  allowClear
                  showSearch
                  filterOption={false}
                  options={sLProfession}
                  value={profession}

                  onSearch={(value) => setSearchFilters({ ...searchFilters, searchProfession: value })}

                  onBlur={() => {
                    // Giữ lại search value khi blur, hoặc có thể reset nếu muốn
                    setSearchFilters({ ...searchFilters, searchProfession: '' }); // Nếu muốn reset khi blur
                  }}
                />
              </Form.Item>
              {/* {typeCustomer === 0 ? (
                <Form.Item
                  name="professionId"
                  rules={[
                    { required: true, message: 'Vui lòng nhập Nghề nghiệp' }
                  ]}
                >
                  <Select
                    placeholder="Nghề nghiệp*"
                    className="custom-page-css border rounded overflow-hidden"
                    // className=""
                    prefix={<FolderOpenOutlined />}

                    allowClear
                    showSearch
                    filterOption={false}
                    options={sLProfession}
                    value={profession}

                    onSearch={(value) => setSearchFilters({ ...searchFilters, searchProfession: value })}

                    onBlur={() => {
                      // Giữ lại search value khi blur, hoặc có thể reset nếu muốn
                      setSearchFilters({ ...searchFilters, searchProfession: '' }); // Nếu muốn reset khi blur
                    }}
                  />
                </Form.Item>
              ) : (
                <Form.Item
                  name="businessFieldId"
                  // className="custom-placeholder"
                  rules={[
                    { required: true, message: 'Vui lòng nhập Ngành nghề kinh doanh' }
                  ]}
                >
                  <Select
                    placeholder="Ngành nghề kinh doanh*"
                    className="custom-page-css border rounded overflow-hidden"
                    prefix={<FolderOpenOutlined />}

                    allowClear
                    showSearch
                    filterOption={false}
                    options={sLBusinessField}
                    value={businessField}
                    onChange={(e) => setBusinessField(e)}

                    onSearch={(value) => setSearchFilters({ ...searchFilters, searchBusinessFieldId: value })}

                    onBlur={() => {
                      // Giữ lại search value khi blur, hoặc có thể reset nếu muốn
                      setSearchFilters({ ...searchFilters, searchBusinessFieldId: '' }); // Nếu muốn reset khi blur
                    }}
                  />
                </Form.Item>
              )} */}

              <Form.List
                name="phone"
                initialValue={[{ phone: "", categoryPhoneId: null }]}
              >
                {
                  (fields, { add, remove }) => (
                    <Flex vertical className="gap-10px">
                      {
                        fields.map((field) => (
                          <div key={field.key} className="custom-page-css flex gap-1">
                            {/* shouldUpdate để đọc trạng thái categoryPhoneId của từng dòng */}
                            <Form.Item noStyle shouldUpdate>
                              {
                                ({ getFieldValue }) => {
                                  const selected = getFieldValue(["phone", field.name, "categoryPhoneId",]);

                                  return (
                                    <Form.Item
                                      className="w-full"
                                      name={[field.name, "phone"]}
                                      rules={[
                                        { required: true, message: "Vui lòng nhập số điện thoại" },
                                        () => ({
                                          validator(_, value) {
                                            if (!value) return Promise.resolve();

                                            const phoneType = getFieldValue(["phone", field.name, "categoryPhoneId",]);

                                            if (!phoneType) return Promise.resolve();

                                            const isHome = phoneType === 1;
                                            const isCompany = phoneType === 2;

                                            if (isHome && !/^0\d{9}$/.test(value)) {
                                              return Promise.reject(
                                                new Error(
                                                  "Số điện thoại không hợp lệ (10 số, bắt đầu bằng 0)"
                                                )
                                              );
                                            }

                                            if (isCompany && !/^0\d{10,11}$/.test(value)) {
                                              return Promise.reject(
                                                new Error(
                                                  "Số điện thoại không hợp lệ (11-12 số, bắt đầu bằng 0)"
                                                )
                                              );
                                            }
                                            return Promise.resolve();
                                          },
                                        }),
                                      ]}
                                    >
                                      <Input
                                        prefix={<PhoneOutlined />}
                                        placeholder="Số điện thoại*"
                                        // className="rs-input h-8"
                                        className="custom-input-css custom-page-css border "
                                        type="tel"
                                        disabled={!selected} // Chỉ nhập khi đã chọn loại điện thoại
                                      />
                                    </Form.Item>
                                  );
                                }}
                            </Form.Item>
                            <Form.Item
                              name={[field.name, "categoryPhoneId"]}
                              rules={[{ required: true, message: "Vui lòng chọn loại điện thoại" }]}
                            >
                              <Select
                                options={sLTypePhone}
                                placeholder="Loại điện thoại"
                                className="custom-page-css border rounded overflow-hidden w-200-px"
                                //  className="rs-input "
                                style={{ outline: 'none', border: '0px' }}
                                onChange={(val) => {
                                  // Nếu bỏ chọn => xóa luôn số điện thoại
                                  if (val == null) {
                                    const curr = (form?.getFieldValue?.("phone") ?? []).slice();
                                    if (curr[field.name]) curr[field.name].phone = "";
                                    form?.setFieldsValue?.({ phone: curr });
                                  }
                                }}
                              />
                            </Form.Item>
                            <img
                              hidden={fields.length <= 1}
                              src={icon_delelte}
                              alt=""
                              className={`ounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"`}
                              onClick={() => remove(field.name)} // dùng field.name an toàn hơn index
                            />
                          </div>
                        ))
                      }
                      <div
                        className={`d-flex align-center gap-1 cursor-pointer text-1890FF pt-1 w-fit`}
                        onClick={() => add({ phone: "", categoryPhoneId: null })}
                      >
                        <PlusSquareOutlined className="text-sm" />
                        <span className="text-sm">Thêm số điện thoại mới</span>
                      </div>
                    </Flex>
                  )
                }
              </Form.List>

              <Form.List name="email" initialValue={[{}]}>
                {(fields, { add, remove }) => (
                  <div className="d-flex flex-column gap-3">
                    {fields.map((field, i) => (
                      <div key={field.key} className="d-flex gap-2">
                        {/* <Form.Item
                          name={[field.name, "email"]}
                          fieldKey={[i, "email"]}
                          className="m-none-form-item text-explan w-full"
                          rules={[
                            {
                              type: "email",
                              message: "Email không hợp lệ",
                            },
                          ]}
                        >
                          <Input
                            prefix={<MailOutlined />}
                            placeholder="Mail"
                            className="custom-input-css custom-page-css border "
                          />
                        </Form.Item> */}
                        <Form.Item
                          name={[field.name, "email"]}
                          fieldKey={[i, "email"]}
                          className="m-none-form-item text-explan w-full"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng nhập email",
                            },
                            {
                              validator(_, value) {
                                if (!value) return Promise.resolve();

                                // Không cho khoảng trắng và Unicode
                                const asciiNoSpaceRegex = /^[\x21-\x7E]+$/;

                                if (!asciiNoSpaceRegex.test(value)) {
                                  return Promise.reject(
                                    new Error("Email không được chứa khoảng trắng hoặc ký tự Unicode")
                                  );
                                }

                                // Validate email: user@domain.tld
                                const emailRegex =
                                  /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

                                if (!emailRegex.test(value)) {
                                  return Promise.reject(
                                    new Error("Email không đúng định dạng")
                                  );
                                }

                                return Promise.resolve();
                              },
                            }
                          ]}
                        >
                          <Input
                            prefix={<MailOutlined />}
                            placeholder="Mail*"
                            className="custom-input-css custom-page-css border"
                          />
                        </Form.Item>
                        <img
                          hidden={fields.length <= 1}
                          src={icon_delelte}
                          alt=""
                          className="rounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"
                          onClick={() => remove(i)}
                        />
                      </div>
                    ))}
                    <div
                      className="d-flex align-center gap-1 cursor-pointer text-1890FF pt-1 w-fit"
                      onClick={() => add({})}
                    >
                      <PlusSquareOutlined className="text-sm" />
                      <span className="text-sm">Thêm mail mới</span>
                    </div>
                  </div>
                )}
              </Form.List>
              <Form.Item
              >
                <Input
                  prefix={<HddOutlined />}
                  disabled
                  placeholder="Đơn vị"
                  // className="rs-input"
                  className="custom-input-css custom-page-css border py-1"
                  value={getTitleSelectOption(fommatSelectOptionUnitByUser(unitByUserPermissionSlice), unitTemp)}
                />
              </Form.Item>

              {/* <Form.Item
                name="contactMethod"
              // rules={[{ required: true, message: 'Vui lòng chọn ít nhất một phương thức liên hệ' }]}
              >
                <Checkbox.Group className='w-full'>
                  <div className="grid-3-cols w-full">
                    {
                      sLContactMethod.map((item) => (
                        <Checkbox
                          key={item.value}
                          value={item.value}
                          className="size-check-box size-check-box-inner p-checkbox icon-check-box"
                        >
                          <span className="text-sm font-regular fw-400">{item.label}</span>
                        </Checkbox>
                      ))
                    }
                  </div>
                </Checkbox.Group>
              </Form.Item> */}
            </div>

            <div className="info-right w-530-px">
              <Form.Item
                name="listType"
              // fieldKey={[i, "provinceId"]}
              // rules={[
              //   {
              //     required: false,
              //     message: "Vui lòng chọn Tỉnh/Thành phố",
              //   },
              // ]}
              // className="w-half"
              >
                <div className="d-flex flex-column gap-3 w-full">
                  <Select
                    placeholder="Tìm và phân loại tình trạng hiện tại của khách hàng"
                    className="custom-page-css border rounded overflow-hidden"
                    mode="multiple"
                    showSearch
                    allowClear
                    filterOption={false}
                    options={fommatSelectOptionListType(sLCustomerType)}
                    value={tagCustomerType}
                    onChange={handleChangeTagCustomertype}
                    onSearch={(value) => setSearchFilters({ ...searchFilters, customerStatus: value })}
                    onDropdownVisibleChange={setOpenTagCustomerType}
                    open={openTagCustomerType}
                    popupClassName="popup-select"
                    suffixIcon={<DownOutlined />}
                    onBlur={() => {
                      // Giữ lại search value khi blur, hoặc có thể reset nếu muốn
                      setSearchFilters({ ...searchFilters, customerStatus: '' }); // Nếu muốn reset khi blur
                    }}
                  />
                  <div
                    className={`${tagCustomerType.length !== 0 ? " d-flex align-center gap-2 flex-wrap" : "none"}`}
                  >
                    {tagCustomerType.map((value, index) => {
                      const selectedOption = sLCustomerType.find((option) => option.id === value);
                      if (!selectedOption) return null;
                      return (
                        <p
                          key={index}
                          className={`bg-${selectedOption.backgroundColor}  rounded-2 text-${selectedOption.color} text-xs px-2 d-flex align-center gap-3-px h-22-px font-regular`}
                        >
                          {selectedOption.codeSymbol}
                          <CloseOutlined
                            className="text-84878C text-xs cursor-pointer"
                            onClick={() =>
                              handleChangeTagCustomertype(
                                tagCustomerType.filter((v) => v !== value)
                              )
                            }
                          />
                        </p>
                      );
                    })}
                  </div>
                </div>
              </Form.Item>
              <Form.Item
                name='informationChannel'
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn Nguồn (kênh tiếp xúc) của khách hàng",
                  },
                ]}
              >
                <Select
                  placeholder="Nguồn (kênh tiếp xúc) của khách hàng*"
                  className="custom-page-css border rounded overflow-hidden"

                  showSearch
                  allowClear
                  filterOption={false}
                  options={sLInformationChannel}
                  onSearch={(value) => setSearchFilters({ ...searchFilters, searchInformationChannel: value })}
                  onBlur={() => {
                    // Giữ lại search value khi blur, hoặc có thể reset nếu muốn
                    setSearchFilters({ ...searchFilters, searchInformationChannel: '' }); // Nếu muốn reset khi blur
                  }}
                />
              </Form.Item>
              <Form.Item name="hobby">
                <div className="d-flex flex-column gap-3 w-full">
                  <Select
                    placeholder="Tìm và chọn sở thích"
                    className="custom-page-css border rounded overflow-hidden"
                    mode="multiple"
                    showSearch
                    allowClear
                    value={valuesTagHobby}
                    filterOption={false}
                    options={sLHobby}
                    onChange={handleChangeTagHobby}
                    onSearch={(value) => setSearchFilters({ ...searchFilters, customerInterest: value })}
                    onDropdownVisibleChange={setOpenTagHobby}
                    open={openTagHobby}
                    popupClassName="popup-select"
                    suffixIcon={<DownOutlined />}

                    onBlur={() => {
                      // Giữ lại search value khi blur, hoặc có thể reset nếu muốn
                      setSearchFilters({ ...searchFilters, customerInterest: '' }); // Nếu muốn reset khi blur
                    }}
                  />
                  <div
                    className={`${valuesTagHobby.length !== 0
                      ? " d-flex align-center gap-2 flex-wrap"
                      : "none"
                      }`}
                  >
                    {valuesTagHobby.map((value, index) => {
                      const selectedOption = sLHobby.find(
                        (option) => option.value === value
                      );
                      if (!selectedOption) return null;
                      return (
                        <p
                          key={index}
                          className="bg-F9F0FF border-D3ADF7 rounded-2 text-722ED1 text-xs px-2 d-flex align-center gap-3-px h-22-px font-regular"
                        >
                          {selectedOption.label}
                          <CloseOutlined
                            className="text-84878C text-xs cursor-pointer"
                            onClick={() =>
                              handleChangeTagHobby(
                                valuesTagHobby.filter((v) => v !== value)
                              )
                            }
                          />
                        </p>
                      );
                    })}
                  </div>
                </div>
              </Form.Item>

              <Form.Item name="groupCustomerId">
                <div className="d-flex flex-column gap-3 w-full">
                  <Select

                    placeholder="Tìm và chọn nhóm khách hàng"
                    className="custom-page-css border rounded overflow-hidden"
                    mode="multiple"
                    showSearch
                    allowClear
                    value={tagGroupPersonally}
                    filterOption={false}
                    options={sLGroup}
                    onChange={handleChangeTagGroup}
                    onSearch={(value) => setSearchFilters({ ...searchFilters, customerGroup: value })}
                    onDropdownVisibleChange={setOpenTagGroup}
                    open={openTagGroup}
                    popupClassName="popup-select"
                    suffixIcon={<DownOutlined />}

                    onBlur={() => {
                      // Giữ lại search value khi blur, hoặc có thể reset nếu muốn
                      setSearchFilters({ ...searchFilters, customerGroup: '' }); // Nếu muốn reset khi blur
                    }}
                  />
                  <div
                    className={`${tagGroupPersonally.length !== 0
                      ? " d-flex align-center gap-2 flex-wrap"
                      : "none"
                      }`}
                  >
                    {tagGroupPersonally.map((value, index) => {
                      const selectedOption = sLGroup.find(
                        (option) => option.value === value
                      );
                      if (!selectedOption) return null;
                      return (
                        <p
                          key={index}
                          className="bg-F0F5FF border-ADC6FF rounded-2 text-2F54EB text-xs px-2 d-flex align-center gap-3-px h-22-px font-regular"
                        >
                          {selectedOption.label}
                          <CloseOutlined
                            className="text-84878C text-xs cursor-pointer"
                            onClick={() =>
                              handleChangeTagGroup(
                                tagGroupPersonally.filter((v) => v !== value)
                              )
                            }
                          />
                        </p>
                      );
                    })}
                  </div>
                </div>
              </Form.Item>

              <Form.Item
                name="description"
                className="m-none-form-item text-explan"
              >
                <TextArea
                  placeholder="Ghi chú khách hàng"
                  className="text-area-hover custom-text-area bg-FCFCFD text-area-input border-F2F4F7 h-80-px"
                />
              </Form.Item>
              <p className="text-base  font-medium text-344054 d-flex gap-2 align-center">
                Thông tin liên lạc
              </p>
              <Form.List name="address" initialValue={[{}]}>
                {(fields, { add, remove }) => (
                  <div className="d-flex flex-column gap-3 ">
                    {fields.map((field, i) => (
                      <div key={i} className="d-flex gap-2 w-full">
                        <div className="d-flex flex-column gap-10-px w-full">
                          <div key={field.key} className="d-flex gap-2">
                            <Form.Item
                              name={[field.name, "provinceId"]}
                              fieldKey={[i, "provinceId"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Vui lòng chọn Chọn tỉnh/ thành phố",
                                },
                              ]}
                              className="w-half"
                            >
                              <Select
                                placeholder="Chọn tỉnh/ thành phố*"
                                className="custom-page-css border rounded overflow-hidden"

                                showSearch
                                allowClear
                                filterOption={false}
                                options={sLProvice}
                                value={provice}
                                onChange={(value) => {
                                  form.setFieldValue(
                                    ["address", field.name, "districtId"],
                                    undefined
                                  );
                                  onChangeProvice_V2(value, i);
                                }}
                                onSearch={(value) => setSearchFilters({ ...searchFilters, searchProvice: value })}
                              />
                            </Form.Item>

                            <Form.Item
                              name={[field.name, "districtId"]}
                              fieldKey={[i, "districtId"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Vui lòng Chọn phường/ xã",
                                },
                              ]}
                              className="w-half"
                            >
                              <Select
                                showSearch
                                allowClear
                                filterOption={false}
                                placeholder="Chọn phường/ xã*"
                                className="custom-page-css border rounded overflow-hidden"
                                options={sLDistrict_V2[i] || []}
                                onSearch={(value) => handleSearchDistrict(value, i)}
                              />
                            </Form.Item>
                          </div>
                          <div className="d-flex gap-2">
                            <Form.Item
                              name={[field.name, "address"]}
                              fieldKey={[i, "address"]}
                              className="w-full"
                              rules={[
                                {
                                  required: true,
                                  message: "Vui lòng nhập Địa chỉ",
                                }
                              ]}
                            >
                              <Input
                                prefix={<HomeOutlined />}
                                placeholder="Địa chỉ* "
                                className="custom-input-css custom-page-css border "
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                              />
                            </Form.Item>
                            <Form.Item
                              name={[field.name, "type"]}
                              fieldKey={[i, "type"]}
                              className="w-150-px"
                              initialValue={i === 0 ? 1 : 0}
                            >
                              <Select
                                allowClear
                                placeholder="Chọn loại địa chỉ"
                                className="custom-page-css border rounded overflow-hidden"

                                disabled={fields.length === 1} // Chỉ có thể chọn loại khi có nhiều hơn 1 địa chỉ
                                options={dataTypeAddress}
                              // onChange={(value) => onChangeTypeAddress(value, i)}

                              />
                            </Form.Item>
                          </div>
                        </div>
                        <CloseCircleOutlined
                          hidden={fields.length <= 1}
                          className={`custom-page-css text-F5222D h-fit text-sm border-EAECF0 p-5-px bg-white rounded cursor-pointer `}
                          onClick={() => {
                            remove(i);

                            // Sau khi xoá, cập nhật lại danh sách type
                            const updatedAddresses = [
                              ...(form.getFieldValue("address") || []),
                            ];
                            // updatedAddresses.splice(i, 1); // loại bỏ phần tử bị xoá

                            // Đảm bảo phần tử đầu tiên (nếu còn) có type = 1
                            const newAddresses = updatedAddresses.map(
                              (item, idx) => ({
                                ...item,
                                type: idx === 0 ? 1 : 0,
                              })
                            );

                            form.setFieldsValue({ address: newAddresses });

                            setSLDistrict_V2((prev) => {
                              const updated: Record<number, OptionType[]> = {};
                              Object.keys(prev).forEach((keyStr) => {
                                const key = Number(keyStr);
                                if (key < i) {
                                  updated[key] = prev[key];
                                } else if (key > i) {
                                  updated[key - 1] = prev[key];
                                }
                              });
                              return updated;
                            });
                          }}
                        />
                        {/* <img
                          hidden={fields.length <= 1}
                          src={icon_delelte}
                          alt=""
                          className="rounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"
                          style={{
                            height: 35,
                            width: 35
                          }}
                        
                        /> */}
                      </div>
                    ))}
                    <div
                      className="d-flex align-center gap-1 cursor-pointer text-1890FF pt-1 w-fit"
                      onClick={() => add({})}
                    >
                      <PlusSquareOutlined className="text-sm" />
                      <span className="text-sm">Thêm địa chỉ mới</span>
                    </div>
                  </div>
                )}
              </Form.List>
            </div>
          </div>
        </div>

        <div className="personal-information__right">
          <UploadImage onChange={setAvatar} />
        </div>
      </div>
    </Form>
  );
};

export default PersonalInformation;
